var map = {
	"./Business-Normal.png": 8025,
	"./Business-Selected.png": 7411,
	"./Dashboard-Normal.png": 9683,
	"./Dashboard-Selected.png": 5713,
	"./IC_Communicate.png": 653,
	"./Ic_Chat.png": 9998,
	"./Ic_Profile_black.png": 6785,
	"./Ic_Profile_white.png": 4075,
	"./Ic_dating-White.png": 5533,
	"./Ic_dating.png": 4929,
	"./LEFT_ERROR.png": 1195,
	"./Logout-Normal.png": 2533,
	"./Logout-Selected.png": 7791,
	"./Notification-Normal.png": 2608,
	"./Setting-Normal.png": 9707,
	"./User-White.png": 3386,
	"./User.png": 5510,
	"./Venue-Normal.png": 4428,
	"./Venue-Selected.png": 7550,
	"./add user.png": 2525,
	"./coins_black.png": 3581,
	"./coins_white.png": 9191,
	"./ic_white_report.png": 960,
	"./legal-document_black.png": 8388,
	"./legal-document_white.png": 7918,
	"./preferences_black.png": 157,
	"./preferences_profile_select.png": 4704,
	"./report.png": 8961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3103;